import { useIsFetching, useIsMutating } from "@tanstack/react-query";
import { LoadingLayer } from "@/components/common/LoadingLayer";

export const QueryLoadingLayer = () => {
  const isLoading = useIsFetching() + useIsMutating() > 0;
  return isLoading ? <LoadingLayer /> : null;
};
